import request from '@/router/axios';
let urlPrefix = '/api/shenbao/shenbao'

/**
 * 获取列表  All接口
 */
// export const getListAll = () => {
//     return request({
//         url: '/api/shenbao/shenbao/all',
//         method: 'get'
//     })
// }

/**
 * 获取列表
 * @param {Number} page
 * @param {Number} limit
 * @param {Object} params
 */
export const getList = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    })
}

export const getInfoByKey = keyUrl => {
    return request(`${urlPrefix}/info/key/${keyUrl}`)
}

export const setScoreWeight = (shenbaoId, data) => {
    return request(`${urlPrefix}/${shenbaoId}/score-weight`, { data }, 'put')
}

// export const getInfoByID = id => {
//     return request(`${urlPrefix}/info/${id}`)
// }

/**
 * 查完成度和总分
 * @param shenbaoId
 * @param userId
 */
export const getUserStatistics = (shenbaoId, userId) => {
    return request(`${urlPrefix}/${shenbaoId}/user/${userId}/statistics`)
}

/**
 * 批量删除
 * @param {Array} ids
 */
export const remove = ids => {
    return request(`${urlPrefix}/deleteBatch`, {
        method: 'delete',
        data: ids
    })
}

/**
 * ID删除
 * @param {Array} id
 */
export const removeByID = id => {
    return request(`${urlPrefix}/${id}`, null, 'delete')
}

/**
 * 获取对象
 * @param {ID} id
 */
export const getEntity = id => {
    return request(`${urlPrefix}/${id}`)
}

/**
 * 添加操作
 * @param {Object} data
 */
export const add = data => {
    return request(`${urlPrefix}`, {
        data,
        method: 'post'
    })
}

/**
 * 编辑操作
 * @param {Object} data
 */
export const update = data => {
    return request(`${urlPrefix}`, {
        data,
        method: 'put'
    })
}

/**
 * 验证/生成实验空间用户
 * @param {String} token
 * @param {String} keyUrl
 */
export const verifyIlabx = (token, keyUrl) => {
    return request(`/api/shenbao/shenbao/ilab/validate/${keyUrl}`, {
        params: {
            token
        }
    })
}

/**
 * 查重操作
 * @param {Object} params
 */
export const duplicateCheck = params => {
    return request(`${urlPrefix}/duplicateCheck`, {
        params: {
            ...params,
        }
    })
}
